/** Map a drag Y (fraction of the composition, 0=top) onto the subtitle
 *  position model. Dragging always yields "middle-center" with
 *  marginVertical 0–100 measuring from the TOP, the full-range form of the
 *  model. (The editor's position values are "top-center" / "middle-center" /
 *  "bottom-center" — anything else falls through the preview's positionMap
 *  to flex-end, which is why an earlier version could not reach the top.) */
export function mapDragToSubtitlePosition(yFrac: number): {
  position: 'middle-center';
  marginVertical: number;
} {
  const y = Math.min(1, Math.max(0, yFrac));
  return { position: 'middle-center', marginVertical: Math.round(y * 100) };
}
